import { timestamp } from "../../app/data/validate";

const sanitize = object => {
    const copy = {}

    for (const field in object) {
        copy[field] = object[field] ?? '';
    }

    return copy;
}

const createFirm = ({ db, firm, office, uid }) => {
    // create a composite id from the firm & office
    const id = `${firm.SraNumber}-${office.OfficeId}`;

    return new Promise(async (resolve, reject) => {
        try {
            var org = await db.get({ path: `organizations/${id}` });

            const address = sanitize(office);

            if (!org) {
                org = {
                    id,
                    name: `${firm.PracticeName} (${office.Town})`,
                    adminOrganization: 'WHuoyDs7zcB8wUU7euiC',
                    phoneNumber: office.PhoneNumber || '',
                    type: 'cais-client',
                    office: address,
                    address: {
                        lines: [
                            address.Address1,
                            address.Address2,
                            address.Address3,
                            address.Address4,
                        ],
                        postcode: office.Postcode
                    },
                    firm: sanitize(firm),
                    ts: timestamp(),
                    uid,
                }

                await db.update({
                    path: `organizations/${id}`,
                    payload: org
                })

                resolve(org);
            }
        }
        catch (error) {
            reject(error);
        }
    });
};

export {
    createFirm
}